// 订单的单个条目
<template>
    <van-panel
        id="orderitem"
        :status="state_name">
        <!-- <van-row slot="header">
            <div class="title"></div>
        </van-row> -->
        <van-cell
            slot="header"
            value-class="headervalue"
            :title="item.bill_no.toLocaleUpperCase() + ' ' + $moment(item.create_date).format('MM-DD HH:mm')" 
            :value="state_name"
            :label="'提货:' + item.plan_date + ' ' + item.plan_time_name"
            @click="toStep"/>
        <van-card
            v-for="it in item.shopmarketorderitems"
            :key="it.id"
            :title="it.car_products_name + ' ' + (it.version_name=='标准版'? '' : it.version_name)"
            :desc="it.car_products_spc"
            :num="it.qty"
            :price="it.price * it.qty -it.global_deduction_amount-it.deduction_amount"
            :thumb="it.img_url"
            @click-thumb="clickItem">
            <!-- <div slot="tags">
                <van-tag plain type="danger">Tag</van-tag>
                <van-tag plain type="danger">Tag</van-tag>
            </div>
            <div slot="footer">
                <van-button size="mini">Button</van-button>
                <van-button size="mini">Button</van-button>
            </div> -->
        </van-card>
        <van-row slot="footer" class="footer">
            <van-col span="12" class="left">{{ footertext }}</van-col>
            <van-col span="12" class="right">
                <van-button size="mini" @click="showCmd(0)" >消息</van-button>
                <van-button v-if="item.state === 0" size="mini" @click="showCmd(-1)">取消</van-button>
                <van-button v-if="item.state === 1" size="mini" @click="showCmd(4)">退货申请</van-button>
                <van-button v-if="item.state === 2" size="mini" @click="showCmd(4)">申请退货</van-button>
            </van-col>
        </van-row>
        <van-popup
            v-model="show"
            close-icon="close"
            position="bottom">
            <van-panel title="录入信息">
                <van-cell-group>
                    <van-field
                        v-model="message"
                        placeholder="信息"
                        type="textarea"
                        rows="4"/>
                </van-cell-group>
                <van-loading vertical v-if="loading"/>
                <div slot="footer">
                    <div class="right">
                        <van-button size="small" type="danger" @click="doOrder">确定</van-button>
                    </div>
                </div>
            </van-panel>
        </van-popup>
    </van-panel>
</template>

<script>
import { OrderApi } from '@/api/market'
import { MsgApi } from '@/api/message'
import { Panel, Cell, Card, Tag, Button, Row, Col, Popup, CellGroup, Field, Toast, Loading } from 'vant'
export default {
    components: {
        [Panel.name]: Panel,
        [Cell.name]: Cell,
        [Card.name]: Card,
        [Tag.name]: Tag,
        [Button.name]: Button,
        [Row.name]: Row,
        [Col.name]: Col,
        [Popup.name]: Popup,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Loading.name]: Loading
    },
    props: [ 'item' ],
    data() {
        return {
            loading: false,
            show: false,
            flag: 0,
            hit: '',
            message: ''
        }
    },
    computed: {
        footertext() {
            // let amt = 0
            let count = 0
            this.item.shopmarketorderitems.forEach(itm => {
                // amt += itm.qty * itm.price * itm.rate / 100
                count += itm.qty
            })
            if (this.item.storedvaluecard_amount > 0) {
                return `储值卡:${this.item.storedvaluecard_amount},现金:${this.item.rev_amount}`
            } else {
                return `商品:${count},现金:${this.item.rev_amount}`
            }
        },
        state_name() {
            let result = this.item.state_name
            if (result==='采购中') {
                result= '待提货'
            }
            return result
        }
    },
    methods: {
        showCmd(state) {
            this.show = true
            this.flag = state
        },
        doOrder() {
            var that = this
            switch (this.flag) {
                case 0: // 信息发送
                    that.loading = true
                    that.axios.post(MsgApi, {
                        orderid: this.item.id,
                        message: this.message
                    }).then((ret) => {
                        that.loading = false
                        if (ret.flag) {
                            this.show = false
                        } else {
                            Toast(ret.info)
                        }
                    })
                    break
                case -1: // 取消
                case 4: // 退货
                    that.loading = true
                    var data = {
                        flag: this.flag,
                        msg: this.message
                    }
                    that.axios.put(OrderApi + this.item.id + '/', data).then((ret) => {
                        that.loading = false
                        if (ret.flag) {
                            this.$router.push(`/user`)
                        } else {
                            Toast(ret.info)
                        }
                    })
                    break
                default: // 
                    break
            }
        },
        clickItem() {
            console.log('i am god')
        },
        toStep() {
            this.$router.push(`/order/${this.item.id}`)
        }
    }
}
</script>

<style scoped lang="less">
#orderitem {
    .headervalue {
        color:#ee0a24;
        font-weight: bold;
    }
    .footer {
        .right {
            text-align: right;
        }

        .left {
            font-size: 0.8em;
        }
    }
}
</style>